import React from "react";
import EntityList from "../../EntityList/EntityList";
import { defineMessages, injectIntl } from "react-intl";

const messages = defineMessages({
  create: {
    id: "app.modificationBookingWindow.addBookingDates",
    description: "Add booking dates",
    defaultMessage: "Add booking dates",
  },
});

function customEntityToListValuesMapper({ entities }) {
  return entities.map(entity => {
    return {
      ...entity,
      startDate: entity.startDate,
      endDate: entity.endDate,
    };
  });
}

class ModificationBookingWindowList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete({ event, entity, idx }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
      idx,
    });
  }

  render() {
    const { config } = this.props;
    const { name, validation, fields, renderers, sorting, locale } = config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      nested,
      entityName,
    } = this.props;
    const { handleDelete } = this;
    return (
      <EntityList
        loading={loading}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        onDelete={handleDelete}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        nested={nested}
        sorting={sorting}
        customEntityToListValuesMapper={customEntityToListValuesMapper}
        currentLocale={locale}
        customCreateButtonMessage={messages}
        showEmptyListColumnNames={false}
      />
    );
  }
}

ModificationBookingWindowList.propTypes = {};

ModificationBookingWindowList.defaultProps = {};

export default injectIntl(ModificationBookingWindowList);
